<footer id="footer" class="mt-auto">
  <div class="container text-start">
    <div class="row justify-content-center row-first">
      <div class="col-sm-12 col-md-3">
        <h5>{{ 'Our offices' | translate }}</h5>
        <p>{{ 'Peru' | translate }}</p>
        <p>{{ 'United States' | translate }}</p>
        <h5>{{ 'Email' | translate }}</h5>
        <p><a class="nav-link text-white" href="email:info@funds4impact.com">info&#64;funds4impact.com</a></p>
      </div>
      <div class="col-sm-12 col-md-3">
        <nav class="nav flex-column">
          <h5>{{ 'Links of interest' | translate }}</h5>
          <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/services'">{{
            'Services' | translate }}</a>
          <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/learning'">{{
            'Learning' | translate }}</a>
          <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/opportunities'">{{
            'Funding opportunities' |
            translate }}</a>
          <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/recruitment'">{{
            'Recruitment' | translate
            }}</a>
          <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/jobs'">{{ 'Jobs' |
            translate }}</a>
          <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/blog'">{{ 'Blog' |
            translate }}</a>
        </nav>
      </div>
      <div class="col-sm-12 col-md-6">
        <app-subscribe-newsletter-small replace-host></app-subscribe-newsletter-small>
        <nav class="nav social-networks">
          <a class="nav-link" rel="noopener" href="https://www.youtube.com/@Funds4impact" target="_blank">
            <img src="assets/icons/youtube.svg" alt="Youtube" title="{{ 'Go to our Youtube page' | translate }}"
              alt="{{ 'Go to our Facebook page' | translate }}" />
          </a>
          <a class="nav-link" rel="noopener" href="https://www.facebook.com/funds4impact" target="_blank">
            <img src="assets/icons/facebook.svg" alt="Facebook" title="{{ 'Go to our Facebook page' | translate }}"
              alt="{{ 'Go to our Facebook page' | translate }}" />
          </a>
          <a class="nav-link" rel="noopener" href="https://www.instagram.com/funds4impact" target="_blank">
            <img src="assets/icons/instagram.svg" alt="Instagram" title="{{ 'Go to our Instagram page' | translate }}"
              alt="{{ 'Go to our Instagram page' | translate }}" />
          </a>
          <a class="nav-link" rel="noopener" href="https://www.linkedin.com/company/funds4impact" target="_blank">
            <img src="assets/icons/linkedin.svg" alt="LinkedIn" title="{{ 'Go to our LinkedIn page' | translate }}"
              alt="{{ 'Go to our LinkedIn page' | translate }}" />
          </a>
          <a class="nav-link" rel="noopener" href="{{ whatsAppUrl }}" target="_blank"
            attr.aria-label="{{ 'Chat on WhatsApp' | translate }}">
            <img src="assets/icons/whatsapp.svg" title="{{ 'Chat on WhatsApp' | translate }}"
              alt="{{ 'Chat on WhatsApp' | translate }}" />
          </a>
        </nav>
      </div>
    </div>
  </div>
  <section>
    <div class="container text-start">
      <div class="row justify-content-between row-second">
        <div class="col-sm-12 col-md-6">
          <p>&copy; {{ year }} {{ siteName }} - {{ 'All rights reserved' | translate }}</p>
        </div>
        <div class="col-sm-12 col-md-6">
          <nav class="nav justify-content-end">
            <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page"
              [routerLink]="'/privacy-policy'">{{ 'Privacy Policy' |
              translate }}</a>
            <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page"
              [routerLink]="'/cookie-policy'">{{ 'Cookie Policy' | translate
              }}</a>
            <a class="nav-link" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/legal-notice'">{{
              'Legal Notice' | translate
              }}</a>
          </nav>
        </div>
      </div>
    </div>
  </section>
</footer>
